import { Button, CircularProgress } from '@mui/material';
import { Editor } from '@tinymce/tinymce-react';
import axios from 'axios';
import moment from 'moment';
import { Fragment, useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { PublicationApi } from '../../api/publication';
import shareImage from '../../assets/icons/share.svg';
import { CustomButton } from '../../components';
import { PublicationItem } from '../../components/PublicationItem';
import { useActions } from '../../hooks/useActions';
import { useLocalStorageSimple } from '../../hooks/useLocalStorage';
import { useMain } from '../../hooks/useMain';
import { useUser } from '../../hooks/useUser';
import { IArticle } from '../../shared/types/articles';
import Heading from '../../ui/heading/Heading';

import './PublicationCard.sass';

export const PublicationCard = () => {
  const { slug } = useParams();

  const { processes } = useMain();
  const { loggedIn, super_admin } = useUser();
  const { setPage, setProcesses, fetchMainCatalog } = useActions();
  const [items, setItems] = useState<IArticle[]>([] as IArticle[]);
  const [article, setArticle] = useState<IArticle>({
    id: 0,
    slug: '',
    title: '',
    img: '',
    content: '',
    topic_id: 0,
    topic_type: '',
    topic_slug: '',
    updated_at: '',
  } as IArticle);

  //Редактор HTML
  const editorRef = useRef(null);
  //Начальное значение редактора HTML
  const [initialValue, setInitialValue] = useState(undefined as any);
  //Отредактирована страница
  const [isChanged, setIsChanged] = useState(false);

  //Отредактировано в редакторе
  const handleEditorChange = (editor_content: any, editor: any) => {
    setIsChanged(true);
  };
  // Добавить/Получить токен
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');
  //Сохранение страницы
  const savePage = () => {
    //Дополнительная проверка на то что пользователь авторизован и супер адмен
    if (loggedIn && super_admin) {
      let cur_content: string = '';
      if (editorRef.current) {
        cur_content = (editorRef.current as any).getContent();
      }
      const saveData = async () => {
        const dataResponce = await axios({
          baseURL: process.env.REACT_APP_BASE_URL_API,
          method: 'patch',
          url: '/api/admin/articles/' + String(article.id),
          headers: {
            'session-token': sessionToken,
          },
          data: {
            action: 'change_article',
            slug: slug,
            title: article.title,
            content: cur_content,
            topic_id: article.topic_id,
            topic_type: article.topic_type,
            is_hide: false,
          },
        });
      };

      saveData();
    } else {
      alert('У вас не прав на редактирование статей');
    }
  };

  let html;
  //Если админ, показываем inline редактор, иначе просто html
  //super_admin возвращает /api/admin/check-login
  //Визуальный редактор TinyMCE

  html = (
    <>
      <input
        id="imgFile"
        type="file"
        name="imgFile"
        style={{ display: 'none' }}
        accept="image/*"
      />

      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        onInit={(evt: any, editor: any) => (editorRef.current = editor)}
        initialValue={initialValue}
        disabled={loggedIn && super_admin ? false : true}
        init={{
          height: 500,
          language: 'ru',
          menubar: true,
          inline: true,
          promotion: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'charmap',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'preview',
            'help',
            'wordcount',
            'image',
          ],
          toolbar:
            'undo redo | blocks | ' +
            'bold italic forecolor backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'image | ' +
            'removeformat | help',
          content_style:
            'body { padding: 5px; font-family:Helvetica,Arial,sans-serif; font-size:14px }',
          a11y_advanced_options: true,
          /* enable title field in the Image dialog*/
          image_title: true,
          /* enable automatic uploads of images represented by blob or data URIs*/
          /*automatic_uploads пока не используется, т.к. проблемы с редактором на фронте (страница сама перезагружается после вставки картинки)
          Поэтому картинки сейчас сохраняются прямо в html в base64 формате
          */
          automatic_uploads: false,
          /*
            URL of our upload handler (for more details check: https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_url)
            here we add custom filepicker only to Image dialog
          */
          images_upload_url:
            process.env.REACT_APP_BASE_URL_API + '/upload_file',
          file_picker_types: 'image',
          /* and here's our custom image picker*/
          file_picker_callback: (cb, value, meta) => {
            if (meta.filetype == 'image') {
              var input_el = document.getElementById('imgFile');
              if (input_el != null) {
                input_el.addEventListener('change', (e: any) => {
                  const file = e.target.files[0];

                  const reader = new FileReader();
                  reader.addEventListener('load', () => {
                    /*
                      Note: Now we need to register the blob in TinyMCEs image blob
                      registry. In the next release this part hopefully won't be
                      necessary, as we are looking to handle it internally.
                    */
                    const id = 'blobid' + new Date().getTime();
                    //const blobCache =  (window as any).tinymce.activeEditor.editorUpload.blobCache;
                    const blobCache = (editorRef.current as any).editorUpload
                      .blobCache;
                    if (reader.result != null) {
                      const base64 = (reader.result as any).split(',')[1];
                      const blobInfo = blobCache.create(id, file, base64);
                      blobCache.add(blobInfo);

                      /* call the callback and populate the Title field with the file name */
                      cb(blobInfo.blobUri(), { title: file.name });
                    }
                  });
                  reader.readAsDataURL(file);
                });

                input_el.click();
              }
            }
          },
        }}
        onEditorChange={handleEditorChange}
      />
    </>
  );
  useEffect(() => {
    (async () => {
      try {
        const { article } = await PublicationApi().getOne(slug);
        const { articles } = await PublicationApi().getLimited(5, article.id);
        setItems(articles);
        setArticle(article);
        setInitialValue(article.content);
      } catch (error) {
        if (error instanceof Error) {
          return console.log(error.message);
        } else {
          return console.log('Loading Error');
        }
      }
    })();
  }, [slug]);

  useEffect(() => {
    setPage('publication'); //На какай странице находимся
    fetchMainCatalog(); //Получение процессов
  }, []);
  useEffect(() => {
    setProcesses(processes);
  }, [processes]);
  return (
    <div className="publication-card">
      <div className="publication-card__wrapper">
        <div className="breadcrumbs">
          <div className="breadcrumbs__item--red">Главная</div>
          <div className="breadcrumbs__item--gray">/</div>
          <Link to={`/articles`}>
            <div className="breadcrumbs__item--red">Публикации</div>
          </Link>
          <div className="breadcrumbs__item--gray">/</div>
          <div className="breadcrumbs__item--gray">
            {article && article?.title}
          </div>
        </div>

        {article && article?.title ? (
          <Fragment>
            <Heading
              title={article && article?.title}
              className="publication-card__title"
            />
            <div className="publication-card__content">
              <div className="publication-card-top">
                <div className="publication-card-top__wrapper">
                  <div className="publication-card-top__left">
                    <div className="publication-card-top__type">
                      {article && article?.topic_type === 'Knowledge::Material'
                        ? 'Материалы'
                        : 'Knowledge::Equipment'
                        ? 'Материалы'
                        : 'Процессы'}
                    </div>
                    <div>/</div>
                    <div className="publication-card-top__date">
                      {moment(
                        article && article?.updated_at,
                        'YYYY-MM-DD'
                      ).format('DD.MM.YYYY')}
                    </div>
                  </div>
                  <div className="publication-card-top__right">
                    {/*<div className="publication-card-top__edit">
                  <img src={editImage} alt="edit" />
                </div>*/}
                    <div className="publication-card-top__share">
                      <img src={shareImage} alt="share" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="publication-card-bottom">
                <div className="publication-card-bottom__wrapper">
                  {/*<div className="publication-card-page--bottom__img">
                <img src={bigImage} alt="img" />
              </div>*/}
                  {/*              <div
                className="publication-card-page--bottom__text"
                dangerouslySetInnerHTML={{
                  __html: Util.textByRegex(content),
                }}
              />*/}

                  {/*<Slider
                slides={[
                  <img src={bigImage} alt="slide" />,
                  <img src={bigImage} alt="slide" />,
                  <img src={bigImage} alt="slide" />,
                ]}
                className="publication-card-page--bottom__slider publication"
              />*/}

                  {loggedIn && super_admin ? (
                    <div className="publication-card-bottom__text">
                      {/*inline редактор, или просто html*/}
                      {html}
                    </div>
                  ) : (
                    <div dangerouslySetInnerHTML={{ __html: initialValue }} />
                  )}

                  {loggedIn && super_admin && isChanged && (
                    <div style={{ width: 200, marginTop: 16 }}>
                      <CustomButton variant="orange" onClick={savePage}>
                        Сохранить
                      </CustomButton>
                    </div>
                  )}

                  <div className="publication-card-review-form">
                    <div className="publication-card-review-form__top">
                      <h1>Оставить комментарий</h1>
                    </div>
                    <textarea className='publication-card-review-form__text' placeholder="Оставьте свой комментарий" />
                    <div className="review-form__bottom">
                      <p>
                        Нажимая кнопку "Отправить", Вы соглашаетесь c условиями
                        <br /> <span>политики конфиденциальности</span>
                      </p>
                      <CustomButton className='publication-card-review-form__buttom' variant="orange">Отправить</CustomButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="publication-card-articles">
              <h2 className="publication-card-articles__title">
                Статьи по теме
              </h2>
              <div className="publication-card-items">
                {items.map((item) => {
                  return <PublicationItem key={item.id} {...item} />;
                })}
              </div>
            </div>
          </Fragment>
        ) : (
          <CircularProgress sx={{ marginTop: '20px' }} />
        )}
      </div>
    </div>
  );
};
